import { c as _c } from "react/compiler-runtime";
import { faroCoreApiClient } from "@api/faro-core-api-client";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { CookieId, IntercomProvider, useIsCookieAccepted } from "@faro-lotv/foreign-observers";
import { runtimeConfig } from "@src/runtime-config";
import { useAppSelector } from "@store/store-helper";
import { loggedInUserSelector } from "@store/user/user-selector";
import { useEffect, useState } from "react";

/**
 * A loader that updates the Intercom-instance with the logged in user data. This is necessary to identify
 * users in Intercom and to distinguish them from (not logged in) visitors
 */
export function IntercomLoader(t0) {
  const $ = _c(11);
  const {
    children
  } = t0;
  const isCookieAccepted = useIsCookieAccepted();
  const {
    handleErrorWithToast
  } = useErrorContext();
  const loggedInUser = useAppSelector(loggedInUserSelector);
  const [intercomInfo, setIntercomInfo] = useState();
  let t1;
  let t2;
  if ($[0] !== handleErrorWithToast || $[1] !== loggedInUser) {
    t1 = () => {
      const updateIntercomUser = async function updateIntercomUser() {
        if (!loggedInUser) {
          return;
        }
        ;
        try {
          const intercomInfo_0 = await faroCoreApiClient.users.getIntercomHash();
          if (intercomInfo_0) {
            setIntercomInfo({
              userId: intercomInfo_0.userId,
              userHash: intercomInfo_0.hash
            });
          }
        } catch (t3) {
          const error = t3;
          handleErrorWithToast({
            id: "load intercom user data",
            title: "Failed to load Intercom.",
            error
          });
        }
      };
      updateIntercomUser();
    };
    t2 = [handleErrorWithToast, loggedInUser];
    $[0] = handleErrorWithToast;
    $[1] = loggedInUser;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== intercomInfo || $[5] !== isCookieAccepted) {
    t3 = !!intercomInfo && isCookieAccepted(CookieId.intercom);
    $[4] = intercomInfo;
    $[5] = isCookieAccepted;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children || $[8] !== intercomInfo || $[9] !== t3) {
    t4 = <IntercomProvider appId={runtimeConfig.features.intercomAppId} user={intercomInfo} enabled={t3}>{children}</IntercomProvider>;
    $[7] = children;
    $[8] = intercomInfo;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}